import moment from "moment";
import "moment/locale/ru";

moment.locale("ru");

const formatCustomDate = (
  year?: number | null | string,
  month?: number | null | string,
  day?: number | null | string
): string => {
  if (year && month && day) {
    return moment(`${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`).format("D MMMM YYYY года");
  } else if (year && month) {
    return moment(`${year}-${String(month).padStart(2, "0")}`).format("MMMM YYYY года");
  } else if (month && day) {
    return moment(`${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`, "MM-DD").format("D MMMM");
  } else if (year) {
    return `${year} года`;
  } else if (day) {
    return `${day}-е число`;
  } else if (month) {
    return moment(`${String(month).padStart(2, "0")}`, "MM").format("MMMM");
  } else {
    return "";
  }
};

export default formatCustomDate;
